import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'clearing-compliance',
        label: 'Compliance',
        to: '/clearing/compliance',
      }),
    }) satisfies AggregateBreadcrumb,
});
